const elements = {
  toggles: document.body.querySelectorAll('.js-search-toggle'),
  close: document.body.querySelector('.js-search-close'),
  form: document.body.querySelector('.js-search-form'),
  searchbar: document.querySelector('.js-searchbar'),
  searchInput: document.querySelector('.js-searchbar-input'),
  searchError: document.body.querySelector('.js-searchbar-input-error'),
  megaNavLink: document.querySelectorAll('.js-meganav__button'),
  megaNavInner: document.querySelectorAll('.js-meganav-inner'),
  currentPageLink: document.querySelector('.js-meganav [aria-current]'),
};

const classes = {
  active: 'is-active',
};

let currentWindowSize;
const desktopWidth = 980;

export function closeSearch() {
  // Set own states
  elements.close.setAttribute('aria-expanded', 'false');

  // Set triggers
  elements.toggles.forEach((el) => {
    el.setAttribute('aria-expanded', 'false');
    el.classList.remove(classes.active);
  });

  // Set target states
  elements.searchbar.setAttribute('aria-hidden', 'true');
  elements.searchbar.classList.remove(classes.active);
  document.body.classList.remove(classes.active);
}

function removeMegaNavStates() {
  elements.megaNavLink.forEach((item) => {
    item.classList.remove(classes.active);
    item.setAttribute('aria-expanded', 'false');
  });

  elements.megaNavInner.forEach((item) => {
    item.classList.remove(classes.active);
  });

  setTimeout(function () {
    elements.toggles[0].focus();
  }, 300);
}

function validateSearchForm(e) {
  // check for empty search
  if (this.searchTerm.value.trim().length === 0) {
    e.preventDefault();
    showError();
    elements.searchInput.addEventListener('input', hideError);
  }
}

function showError() {
  elements.searchError.innerHTML = `<span class="u-error-block">Please enter a search term.</span>`;
  elements.form.classList.add('has-error');
}

function hideError() {
  elements.searchError.innerHTML = null;
  elements.form.classList.remove('has-error');
}

function toggleVisibility(e) {
  const trigger = e.target;
  const buttonState = trigger.getAttribute('aria-expanded');
  const closeSearchBtn = elements.searchbar.querySelector('.js-search-close');
  const hideCurrentClass = 'is-current-hide';

  // Toggle the aria-expanded state
  if (buttonState === 'false') {
    trigger.setAttribute('aria-expanded', 'true');
    closeSearchBtn.setAttribute('aria-expanded', 'true');
    elements.currentPageLink ? elements.currentPageLink.classList.add(hideCurrentClass) : '';
    removeMegaNavStates();
    elements.form.addEventListener('submit', validateSearchForm);
    setTimeout(function () {
      elements.searchInput.focus();
    }, 300);
  } else {
    trigger.setAttribute('aria-expanded', 'false');
    closeSearchBtn.setAttribute('aria-expanded', 'false');
    elements.currentPageLink ? elements.currentPageLink.classList.remove(hideCurrentClass) : '';
    elements.form.removeEventListener('submit', validateSearchForm);
    setTimeout(function () {
      elements.toggles[0].focus();
    }, 300);
  }

  trigger.classList.toggle(classes.active); // Set the toggle to active
  elements.searchbar.classList.toggle(classes.active); // Set the target active
}

function windowResize() {
  if (currentWindowSize === window.innerWidth) {
    return;
  }

  currentWindowSize = window.innerWidth;

  if (currentWindowSize >= desktopWidth) {
    elements.toggles.forEach((item) => {
      item.classList.remove(classes.active);
      item.setAttribute('aria-expanded', false);
    });
    elements.searchbar.classList.remove(classes.active);
    elements.close.setAttribute('aria-expanded', false);
  }
}

function init() {
  if (elements.toggles.length) {
    elements.toggles.forEach((el) => {
      el.removeAttribute('hidden');
      el.addEventListener('click', toggleVisibility);
    });
    window.addEventListener('resize', windowResize);
  }

  if (elements.close) {
    elements.close.addEventListener('click', closeSearch);
  }
}

export default init;
